import { useState } from 'react';
import { X } from 'lucide-react';

/**
 * Issue #184 — 受控的「名称列表」编辑器（课程分类 / 岗位通用）。
 * 纯展示 + 回调，不直接发请求；保存由父卡片统一处理。去重 / 去空白在添加时即时处理。
 */
const INPUT =
  'flex-1 rounded-md border border-slate-300 px-2.5 py-1.5 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-100';
const ADD_BTN =
  'inline-flex items-center gap-1 rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm text-slate-600 transition hover:bg-slate-50 disabled:opacity-60';

export function NameListEditor({
  items,
  onChange,
  disabled,
  placeholder = '输入名称后回车添加',
  maxLen = 32,
  emptyHint = '暂无条目',
}: {
  items: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  maxLen?: number;
  emptyHint?: string;
}) {
  const [draft, setDraft] = useState('');

  const add = () => {
    const name = draft.trim();
    if (name.length === 0 || name.length > maxLen) return;
    if (items.includes(name)) {
      setDraft('');
      return;
    }
    onChange([...items, name]);
    setDraft('');
  };

  const remove = (name: string) => onChange(items.filter((i) => i !== name));

  return (
    <div>
      <div className="flex flex-wrap gap-1.5">
        {items.length === 0 ? (
          <span className="text-xs text-slate-400">{emptyHint}</span>
        ) : (
          items.map((name) => (
            <span
              key={name}
              className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs text-slate-700"
            >
              {name}
              {!disabled ? (
                <button
                  type="button"
                  className="text-slate-400 hover:text-rose-600"
                  onClick={() => remove(name)}
                  aria-label={`移除 ${name}`}
                >
                  <X className="h-3 w-3" />
                </button>
              ) : null}
            </span>
          ))
        )}
      </div>
      {!disabled ? (
        <div className="mt-2 flex items-center gap-2">
          <input
            className={INPUT}
            value={draft}
            maxLength={maxLen}
            placeholder={placeholder}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                add();
              }
            }}
          />
          <button type="button" className={ADD_BTN} onClick={add} disabled={draft.trim().length === 0}>
            添加
          </button>
        </div>
      ) : null}
    </div>
  );
}
